import { AccountTypes, UserRole } from '@shared/utils/base-auth';
import { ShareTypeModel } from '@shared/utils/list-officer';

export class OfficerBase {
  constructor(
    public uid: string,
    public firstName: string,
    public lastName: string,
    public isDeleted: boolean | null,
    public emailAddress: string,
    public timezone: string,
    public employeeID: string,
    public pictureFullPath: string | null
  ) {}
}

export class Officer extends OfficerBase {
  constructor(
    uid: string,
    firstName: string,
    lastName: string,
    isDeleted: boolean | null,
    emailAddress: string,
    timezone: string,
    employeeID: string,
    pictureFullPath: string | null,
    public accountType: AccountTypes,
    public inviteSent: boolean,
    public phone: string,
    public role: UserRole,
    public shareType: ShareTypeModel,
    public respondsTo: OfficerBase | null,
    public children: string,
    public isInviting: boolean = false
  ) {
    super(uid, firstName, lastName, isDeleted, emailAddress, timezone, employeeID, pictureFullPath);
  }
}

export class OfficerBaseResponse {
  constructor(
    public uid: string,
    public firstName: string,
    public lastName: string,
    public deletedOn: Date | null,
    public emailAddress: string,
    public timezone: string,
    public employeeID: string,
    public pictureFullPath: string | null,
    public inviteSent: boolean,
    public accountType: AccountTypes
  ) {}
}

export class OfficerResponse extends OfficerBaseResponse {
  constructor(
    uid: string,
    firstName: string,
    lastName: string,
    deletedOn: Date | null,
    emailAddress: string,
    timezone: string,
    employeeID: string,
    pictureFullPath: string | null,
    inviteSent: boolean,
    accountType: AccountTypes,
    public phone: string,
    public role: UserRole,
    public shareType: ShareTypeModel,
    public respondsTo: OfficerBaseResponse | null,
    public children: string
  ) {
    super(uid, firstName, lastName, deletedOn, emailAddress, timezone, employeeID, pictureFullPath, inviteSent, accountType);
  }
}

export class OfficerForOrganizationChart {
  constructor(
    public uid: string,
    public firstName: string,
    public lastName: string,
    public pictureFullPath: string | null,
    public respondToFk: string | null,
    public hasChildren: boolean,
    public emailAddress: string,
    public role: UserRole
  ) {}
}

export class PatchUserRespondsRequest {
  constructor(public RespondToUid?: string) {}
}
